'use client';

import { useEffect } from 'react';

// Keep error copy in sync with error.tsx (duplication is intentional —
// global-error replaces the root layout and cannot import shared modules)
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // biome-ignore lint/suspicious/noConsole: global-error replaces the root layout, so no providers (including LogTunnelProvider) are available
    console.error('Unhandled error caught by global error boundary', {
      message: error.message,
      digest: error.digest,
    });
  }, [error]);

  return (
    <html lang="en" suppressHydrationWarning>
      <head>
        <style
          dangerouslySetInnerHTML={{
            __html: `
              @media (prefers-color-scheme: dark) {
                body { background-color: #0a0a0a !important; color: #fafafa !important; }
                .error-muted { color: #a3a3a3 !important; }
                .error-button { background-color: #fafafa !important; color: #0a0a0a !important; }
              }
            `,
          }}
        />
      </head>
      <body
        style={{
          margin: 0,
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
          backgroundColor: '#ffffff',
          color: '#0a0a0a',
        }}
      >
        <div
          style={{
            display: 'flex',
            minHeight: '100vh',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '2rem',
          }}
        >
          <div style={{ maxWidth: '28rem', textAlign: 'center' }}>
            <h1 style={{ fontSize: '1.5rem', fontWeight: 600, marginBottom: '1.5rem' }}>
              Something went wrong
            </h1>
            <p className="error-muted" style={{ color: '#737373', marginBottom: '1.5rem' }}>
              An unexpected error occurred. Please try again, and if the problem persists, try
              refreshing the page.
            </p>
            <button
              type="button"
              className="error-button"
              onClick={reset}
              style={{
                backgroundColor: '#171717',
                color: '#fafafa',
                padding: '0.5rem 1rem',
                borderRadius: '0.375rem',
                fontSize: '0.875rem',
                fontWeight: 500,
                border: 'none',
                cursor: 'pointer',
              }}
            >
              Try again
            </button>
          </div>
        </div>
      </body>
    </html>
  );
}
